import React from 'react';

import { LeadIntegrationsPanel } from './LeadIntegrationsPanel';

// National Advocates firm ID — hardcoded for now since leads are only
// configured for this firm.
const NATIONAL_ADVOCATES_FIRM_ID = 'b550a5cd-8756-433a-91f2-a547fb146ffc';

export const LeadsPage = () => {
  return (
    <div className="mx-auto max-w-7xl p-6">
      <LeadIntegrationsPanel firmId={NATIONAL_ADVOCATES_FIRM_ID} />
    </div>
  );
}
